(() => {
  function init() {
    const containers = document.querySelectorAll('.lp-inline-recs');
    if (!containers.length) return;
    containers.forEach(el => new LpInlineRecs(el));
  }

  class LpInlineRecs {
    constructor(el) {
      this.el = el;
      this.limit = parseInt(el.dataset.limit) || 4;
      this.heading = el.dataset.heading || el.dataset.h || 'Polecane produkty';
      this.run();
    }

    async run() {
      const isAvailable = p => p.available === true || p.variants.some(v => v.available === true);

      const fetchAvailable = async (url) => {
        const res = await fetch(url);
        if (!res.ok) return [];
        const { products } = await res.json();
        return products.filter(isAvailable).slice(0, this.limit);
      };

      try {
        let available = [];

        if (this.el.dataset.collection) {
          available = await fetchAvailable(`/collections/${this.el.dataset.collection}/products.json?limit=8`);
        } else {
          for (const handle of this.detectHandles().slice(0, 3)) {
            available = await fetchAvailable(`/collections/${handle}/products.json?limit=8`);
            if (available.length) break;
          }
        }

        if (!available.length) available = await fetchAvailable('/products.json?limit=8');
        if (!available.length) return;
        this.render(available);
      } catch (e) {
        // fail silently
      }
    }

    detectHandles() {
      const content = document.querySelector('.article__content');
      if (!content) return [];
      const seen = new Set();
      const handles = [];
      for (const a of content.querySelectorAll('a[href*="/collections/"]')) {
        if (!(this.el.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
        const m = a.pathname.match(/\/collections\/([^/?#]+)/);
        if (m && m[1] !== 'all' && !seen.has(m[1])) {
          seen.add(m[1]);
          handles.push(m[1]);
        }
      }
      return handles.reverse(); // closest link first
    }

    badges(product) {
      const cfg = window.lpRecBadge || {};
      const out = [];

      if (cfg.showSale !== false) {
        const price = parseFloat(product.variants[0].price);
        const comparePrice = parseFloat(product.variants[0].compare_at_price);
        if (comparePrice && comparePrice > price) {
          let label;
          if (cfg.saleType === 'show_percentage') {
            label = '-' + Math.round((comparePrice - price) / comparePrice * 100) + '%';
          } else if (cfg.saleType === 'show_amount') {
            label = '-' + this.formatMoney(comparePrice - price);
          } else {
            label = cfg.saleLabel || 'Promocja';
          }
          out.push(`<span class="f-badge f-badge--sale" aria-hidden="true">${label}</span>`);
        }
      }

      for (const tag of (product.tags || [])) {
        if (!tag.startsWith('tag__')) continue;
        const parts = tag.slice(5).split('_');
        const type = parts[0];
        const name = parts[parts.length - 1];
        out.push(`<span class="f-badge f-badge--${type}" aria-hidden="true">${name}</span>`);
      }

      return out.length ? `<div class="product-card__badge">${out.join('')}</div>` : '';
    }

    formatMoney(price) {
      const amount = parseFloat(price);
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
      const lang = document.documentElement.lang || 'pl';
      try {
        return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(amount);
      } catch (e) {
        return price;
      }
    }

    imgUrl(src, w = 400) {
      if (!src) return '';
      return src.replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`);
    }

    render(products) {
      const cards = products.map(p => {
        const img = p.images[0];
        const imgTag = img
          ? `<img src="${this.imgUrl(img.src)}" alt="${(img.alt || p.title).replace(/"/g, '&quot;')}" loading="lazy" width="400" height="600">`
          : '<div class="lp-rec__img-placeholder"></div>';
        const price = this.formatMoney(p.variants[0].price);
        const comparePrice = p.variants[0].compare_at_price
          ? `<s class="lp-rec__compare-price">${this.formatMoney(p.variants[0].compare_at_price)}</s>`
          : '';
        return `<div class="lp-rec__item">
          <a href="/products/${p.handle}" class="lp-rec__card">
            <div class="lp-rec__img">${imgTag}${this.badges(p)}</div>
            <div class="lp-rec__info">
              <div class="lp-rec__title">${p.title}</div>
              <div class="lp-rec__price">${price}${comparePrice}</div>
            </div>
          </a>
        </div>`;
      }).join('');

      this.el.innerHTML = `
        <div class="lp-rec__heading">${this.heading}</div>
        <div class="lp-rec__track">${cards}</div>
      `;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
